module.exports = __webpack_public_path__ + "static/img/退房.7cfc3bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/center/退房.png
// module id = 30
// module chunks = 18